module.exports = __webpack_public_path__ + "static/media/img5.88fcc7ca.png";